import React from "react";
import styled from "styled-components";
import { ReactComponent as Plus } from "../../../../assets/icons/PlusInButton.svg";
import Button from "../../../../components/atoms/Button";
import { theme } from "../../../../theme";

interface Props {
  disabled?: boolean;
  onClick?: () => void;
}
const PlusButtonRow: React.FC<Props> = ({ disabled, onClick }) => {
  return (
    <StyledPlusWrapper>
      {" "}
      <Button
        size="small"
        ghost
        style={{
          display: "flex",
          alignItems: "center",
        }}
        disabled={disabled}
        onClick={onClick}
      >
        <PlusIcon
          fill={theme.colors.mainPrimary3}
          stroke={disabled ? theme.colors.gray6 : theme.colors.mainPrimary3}
        />{" "}
        추가
      </Button>
    </StyledPlusWrapper>
  );
};
const StyledPlusWrapper = styled.div`
  height: 40px;
  padding: 0px 16px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-shadow: inset 0px -1px 0px #efefef;
  width: 100%;
`;
const PlusIcon = styled(Plus)`
  margin-right: 4px;
`;

export default PlusButtonRow;
